export class addUserModel{
    Id:number;
    Salutation:string;
    FirstName:string;
    Middlename:string
    LastName:string;
    Code:string;
    BranchId:number;
    Gender:number;
    EmailAddress:string;
    Username:string;
    PhoneNumber:string;
    Password:string;
    UserId:number;
    Statusid:number;
    Enddate:string;
    Profilephoto:string;
    IsSchoolAdminUser:boolean;
}
export class addUserFirebaseModel{
    IsSchoolAdminUser:boolean;
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/adduser/adduser.model.ts